import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CheckoutDetailSectionComponent} from './checkout-detail-section.component';
import {ExplanationBoxModule} from '@app/shared/explanation-box/explanation-box.module';
import {I18nModule} from '@spartacus/core';
import {IconButtonTooltipModule} from '@dcp/configurator';


@NgModule({
  declarations: [CheckoutDetailSectionComponent],
  imports: [
    CommonModule,
    ExplanationBoxModule,
    I18nModule,
    IconButtonTooltipModule,
  ],
  exports: [
    CheckoutDetailSectionComponent
  ]
})
export class CheckoutDetailSectionModule {
}
